import { Controller } from "@hotwired/stimulus"
import { client } from "./../components/Client"

export default class extends Controller {
  static targets = ["response"]
  static values = { fileName: String }

  connect() {
    // Initialize the controller and listen for dialog open events
    document.addEventListener('dialog:opened', this.onDialogOpened.bind(this))
  }

  disconnect() {
    // Clean up event listeners when controller is disconnected
    document.removeEventListener('dialog:opened', this.onDialogOpened.bind(this))
  }

  onDialogOpened(event) {
    if (event.target.contains(this.element)) {
      this.getHelp()
    }
  }

  getHelp() {
    var prompt = ""
    if (this.hasFileNameValue && this.fileNameValue) {
      prompt = window.t('ai.request.convert_unsupported_format_to_pdf') + `*.${client.extractFileExt(this.fileNameValue)}*`

    } else {
      prompt = "Please provide information about PDF conversion options"
    }

    // Show loading state
    this.responseTarget.innerHTML = '<div class="text-center"><div class="spinner-border text-primary" role="status"></div><p class="mt-2">Ожидаем ответ от ИИ</p></div>'

    // Make a request to the API
    fetch('/api/v1/ai_help.json', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'X-CSRF-Token': document.querySelector('meta[name="csrf-token"]').content
      },
      body: JSON.stringify({ prompt: prompt })
    })
      .then(response => {
        if (!response.ok) {
          throw new Error(`Request failed with status ${response.status}`)
        }
        return response.json()
      })
      .then(data => {
        console.log('Response data:', data)

        // Format and display the response
        if (data.success && data.response) {
          this.responseTarget.innerHTML = `
            <div class="ai-response">
              <h4 class="mb-3">Ответ ИИ:</h4>
              <div class="p-3 bg-light rounded">
                ${this.formatResponse(data.response)}
              </div>
            </div>
          `
        } else {
          this.responseTarget.innerHTML = '<div class="alert alert-warning">Нет ответа от ИИ.</div>'
        }
      })
      .catch(error => {
        console.error('Error fetching AI help:', error)
        this.responseTarget.innerHTML = `<div class="alert alert-danger">Ошибка: ${error.message}</div>`
      })
  }

  formatResponse(text) {
    // Convert plain text to HTML with paragraphs and preserve line breaks
    if (!text) return ''

    // Convert markdown-style formatting if present
    return text
      .replace(/\n\n/g, '</p><p>') // Convert paragraph breaks
      .replace(/\n/g, '<br>') // Convert line breaks
      .replace(/\*\*(.*?)\*\*/g, '<strong>$1</strong>') // Bold
      .replace(/\*(.*?)\*/g, '<em>$1</em>') // Italic
      .replace(/`(.*?)`/g, '<code>$1</code>') // Code
      .replace(/^(.+)$/gm, '$1<br>') // Add breaks after each line
      .replace(/<br>$/, '') // Remove trailing break
  }
}

